import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import {
  LuChevronUp, LuChevronDown,
  LuArrowLeft, LuReply, LuReplyAll, LuForward, LuTrash2, LuPrinter,
  LuSendHorizonal, LuX, LuBold, LuItalic, LuUnderline, LuAlignLeft,
  LuAlignCenter, LuAlignRight, LuMailOpen, LuAlignJustify, LuMoreVertical, LuPencil
} from 'react-icons/lu';
import { dashboardActions } from "../../../_actions";
import { GoMail } from "react-icons/go";
import DeleteReplyModal from "./Modals/DeleteReplyModal";

const isMobile = window.innerWidth <= 700;

class InboxActivity extends Component {
  constructor(props) {
    super(props);

    this.editorRef = createRef();

    this.state = {
      selectedMail: 0,
      selectedMailId: "",
      showReply: false,
      replyEdit: false,
      replyData: {
        mailLibId: "",
        id: "",
        to: "",
        subject: "",
        body: ""
      },
      selectedId: 3,
      showMobileDetail: false,
      activeViewId: "",
      crrReplyDetails: {},
      showInboxIntro: true
    };
  }

  componentDidMount() {
    this.props.dispatch(dashboardActions.getConnectDetails({}));
    // this.props.dispatch(dashboardActions.saveInsightActivityTracking({
    //   activity: "Viewing Inbox Activty!"
    // }));

    this.props.dispatch(dashboardActions.getInsightMailLibraryIntro({}));

    this.props.dispatch(dashboardActions.getMeetingLinkDetails({}));
    this.props.dispatch(dashboardActions.getMailBoxDetails({}, "getInsightMailReply"));
  }

  /* OPEN REPLY */
  handleOpenReply = () => {
    const { dashboard } = this.props;
    const { getMailBoxDetailsData = [] } = dashboard;
    const { selectedMail } = this.state;

    let mail = getMailBoxDetailsData[selectedMail] || {};

    this.setState(
      {
        showReply: true,
        replyData: {
          to: mail.senderEmail || mail.recipientEmail || "",
          subject: `Re: ${mail.subject || ""}`,
        },
      },
      () => {
        // set initial content ONCE
        if (this.editorRef.current) {
          this.editorRef.current.innerHTML = `<p>Dear ${mail.senderName || "Sir"
            },</p><br/>`;
        }
      }
    );
  };

  /* SEND MAIL */
  handleSendReply = () => {
    let { dashboard } = this.props;
    let { getMailBoxDetailsData = [] } = dashboard;

    const { replyData, selectedMailId } = this.state;
    let body = this.editorRef.current ? this.editorRef.current.innerHTML : "";

    let initMailLibId = "";
    if (selectedMailId) {
      initMailLibId = selectedMailId;
    } else {
      if (getMailBoxDetailsData && getMailBoxDetailsData[0]["id"] && getMailBoxDetailsData[0]["id"]) {
        initMailLibId = getMailBoxDetailsData[0]["id"];
      }
    }

    let data = {
      mailLibId: initMailLibId,
      to: replyData.to,
      subject: replyData.subject,
      body: body,
    };

    this.props.dispatch(dashboardActions.replyInsightMail(data));
    this.props.dispatch(dashboardActions.saveInsightActivityTracking({
      activity: "Replied to Mail!"
    }));
    this.setState({ showReply: false });
  };



  handleSelect = (mail, i) => {
    if (mail === "intro") {
      this.setState({ showInboxIntro: true })
    } else {
      this.setState({ showInboxIntro: false })
      let data = {
        mailLibId: mail.id
      }
      this.props.dispatch(dashboardActions.getInsightMailReply(data));
      this.setState({ selectedMail: i, selectedMailId: mail.id, showMobileDetail: true })
    }

  }

  formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(Number(timestamp));
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day} ${month}`;
  };

  toggleViewMenu = () => {
    this.setState({ activeViewId: !this.state.activeViewId });
  };

  toggleMenu = (e, replyId) => {
    e.stopPropagation();
    this.setState({ activeMenuId: this.state.activeMenuId === replyId ? null : replyId });
  };

  toggleMenuMainReply = (e, activeMail) => {
    e.stopPropagation();
    this.setState({ activeMenueMail: this.state.activeMenueMail === activeMail ? null : activeMail });
  };

  goToBack = () => {
    let { showMobileDetail, showReply } = this.state;
    if (showReply) {
      this.setState({
        showReply: false, replyData: {
          id: "",
          to: "",
          subject: "",
          body: "",
          mailLibId: ""
        }
      });
    } else {
      if (isMobile) {
        if (showMobileDetail) {
          this.setState({ selectedMail: 0, selectedMailId: "", showMobileDetail: false });
        } else {
          window.history.back();
        }
      } else {
        window.history.back();
      }
    }
  };


  editReplyMail = (reply) => {
    let temp = {
      id: reply.id,
      to: reply.to,
      subject: reply.subject,
      body: reply.body,
      mailLibId: reply.mailLibId
    }
    console.log("reply.body------>", reply.body)
    this.setState({
      replyData: temp,
      showReply: true,
      replyEdit: true
    },
      () => {
        // set initial content ONCE
        if (this.editorRef.current) {
          this.editorRef.current.innerHTML = reply.body;
        }
      }
    )
  }

  deleteReplyConfirm = (reply) => {
    this.setState({ showDeleteConfirm: true, crrReplyDetails: reply });
  }
  onCloseDeleteConfirm = (reply) => {
    this.setState({ showDeleteConfirm: false, crrReplyDetails: {} });
  }

  deleteReplyMail = () => {
    let { crrReplyDetails } = this.state;
    const reply = crrReplyDetails;
    let data = {
      id: reply.id
    }
    const temp = { mailLibId: reply.mailLibId };
    this.props.dispatch(dashboardActions.deleteReplyInsightMail(data, temp));
    this.setState({
      replyData: {
        id: "",
        to: "",
        subject: "",
        body: "",
        mailLibId: ""
      },
      showReply: false,
      replyEdit: false,
      showDeleteConfirm: false
    });
  }

  handleEditReply = () => {
    let { replyData } = this.state;
    let body = this.editorRef.current ? this.editorRef.current.innerHTML : "";

    let data = {
      id: replyData.id,
      to: replyData.to,
      subject: replyData.subject,
      body: body
    }
    const temp = { mailLibId: replyData.mailLibId };
    this.props.dispatch(dashboardActions.updateReplyInsightMail(data, temp));
    this.setState({
      replyData: {
        id: "",
        to: "",
        subject: "",
        body: "",
        mailLibId: ""
      },
      showReply: false,
      replyEdit: false
    });
  }

  render() {
    let { showInboxIntro, showDeleteConfirm, activeViewId, replyEdit, showMobileDetail, selectedMail, selectedMailId, showReply, replyData } = this.state;
    let { dashboard } = this.props;
    let { getInsightMailLibraryIntroData: inboxIntroObj = {}, getMeetingLinkDetailsData = [], getMailBoxDetailsData = [], getInsightMailReplyData = [] } = dashboard;

    const inboxIntro = inboxIntroObj?.body ?? "";
    console.log("inboxIntro--------------->", inboxIntro)

    const inboxData = getMailBoxDetailsData && getMailBoxDetailsData.length > 0 ? getMailBoxDetailsData.map((mail) => ({
      id: mail.id,
      sender: mail.senderName,
      recipient: mail.recipientName,
      subject: mail.subject,
      date: this.formatDate(mail.createdAt),
      unread: false,
      email: mail.subject,
      recipientEmail: mail.recipientEmail,
      fullDate: this.formatDate(mail.createdAt),
      message: mail.preview
    })) : [];

    let activeMail = getMailBoxDetailsData[selectedMail];

    // console.log("activeMail--------------->", activeMail)

    let { getConnectDetailsData: x } = dashboard;
    let logo = x?.logo || "";

    return (
      <LayoutWrap logo={logo}>
        <div className="flex flex-col h-full bg-white textblack">
          {/* Header */}
          <div className="flex items-center gap-4 p-4 border-b border-gray-300">
            <button onClick={() => this.goToBack()} className="p-2 rounded-full bg-indigo-100 text-indigo-600">
              <LuArrowLeft size={24} />
            </button>
            <h1 className="md:text-2xl text-xl font-medium textblack">Inbox Activity</h1>
          </div>

          <div className="flex flex-1 overflow-hidden">
            {/* Sidebar - Inbox List */}
            {(isMobile === true ? (!showMobileDetail) : true) &&
              <aside className={`w-full lg:w-[400px] border-r border-gray-300 overflow-y-auto block`}>

                <div
                  onClick={() => this.handleSelect("intro")}
                  className={`p-3 border-b border-gray-300 cursor-pointer transition-colors flex gap-3 px-3 py-6 ${showInboxIntro ? 'bg-indigo-100' : 'hover:bg-gray-100'
                    }`}
                >
                  <div className="flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="text-indigo-600"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 16v-4"></path>
                      <path d="M12 8h.01"></path>
                    </svg>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between items-center gap-3">
                      <h3 className="text-lg font-semibold text-gray-900 truncate">
                        Inbox Activity Introduction
                      </h3>

                      <span className="text-sm text-indigo-600 whitespace-nowrap">
                        Today
                      </span>
                    </div>
                  </div>
                </div>



                {inboxData.map((item, i) => (
                  <div
                    key={item.id}
                    onClick={() => this.handleSelect(item, i)}
                    className={`p-3 border-b border-gray-300 cursor-pointer transition-colors flex gap-3 px-3 py-6 ${(!showInboxIntro && (selectedMail === i)) ? 'bg-indigo-100' : 'hover:bg-gray-100'
                      }`}
                  >
                    <div className="mt-1">
                      {item.unread ? (
                        <GoMail className="textblack" size={24} />
                      ) : (
                        <LuMailOpen className="text-indigo-600" size={24} />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex justify-between items-baseline">
                        <h3 className="text-base font-medium truncate">{item.sender}</h3>
                        <span className="text-sm text-indigo-600">{item.date}</span>
                      </div>
                      <p className="text-sm textblack truncate">{item.subject}</p>
                    </div>
                  </div>
                ))}
              </aside>
            }

            {showInboxIntro ?
              <>
                <main className={`flex-1 flex flex-col bg-white overflow-y-auto ${!this.state.showMobileDetail ? 'hidden lg:flex' : 'flex'}`}>
                  <div className="md:p-6 p-4 w-full">
                    <div className="flex items-center justify-center gap-3 p-4 border-b border-gray-300">
                      <h2 className="md:text-2xl text-xl font-medium mb-6">Inbox Activty Introduction</h2>
                    </div>

                    <div
                      className="textblack text-sm leading-relaxed space-y-4"
                      dangerouslySetInnerHTML={{ __html: inboxIntro }}
                    />

                  </div>
                </main>
              </>
              :
              <>
                {showReply && (
                  <main className="flex-1 flex flex-col bg-white overflow-y-auto">
                    {/* Top Action Bar */}
                    <div className="flex items-center justify-end gap-3 p-4 border-b border-gray-300">
                      <button onClick={() => this.setState({
                        showReply: false, replyEdit: false, replyData: {
                          id: "",
                          to: "",
                          subject: "",
                          body: "",
                          mailLibId: ""
                        }
                      })} className="flex items-center gap-2 px-4 py-1.5 border border-gray-300 text-indigo-600 rounded-md font-medium hover:text-indigo-700 hover:bg-indigo-100">
                        <LuX size={18} /> Discard
                      </button>
                      <button onClick={() => replyEdit ? this.handleEditReply() : this.handleSendReply()} className="flex items-center gap-2 px-4 py-1.5 bg-indigo-600 text-white rounded-md font-medium hover:bg-indigo-700">
                        <LuSendHorizonal size={18} /> Send
                      </button>
                    </div>

                    {/* Form Fields */}
                    <div className="md:p-8 p-4 md:max-w-[90%] w-full mx-auto space-y-6">
                      <div className="grid md:grid-cols-[80px_1fr] grid-cols-[50px_1fr] items-center gap-4">
                        <label className="md:text-lg text-sm font-medium textblack">To:</label>
                        <input type="text" name="to" value={replyData.to} onChange={(e) => this.setState({ replyData: { ...replyData, to: e.target.value, }, })}
                          className="border-b border-gray-300 py-2 focus:border-purple-600 outline-none textblack"
                        />

                        <label className="md:text-lg text-sm font-medium textblack">Subject:</label>
                        <input type="text" name="subject" value={replyData.subject} onChange={(e) => this.setState({ replyData: { ...replyData, subject: e.target.value, }, })} className="border-b border-gray-300 py-2 focus:border-purple-600 outline-none textblack" />
                      </div>

                      {/* Text Editor Container */}
                      <div className="border border-gray-300 rounded-lg overflow-hidden mt-8">
                        {/* Toolbar */}
                        <div className="flex flex-wrap items-center gap-1 p-2 bg-white border-b border-gray-300">
                          <ToolbarButton onClick={() => document.execCommand("bold")} icon={<LuBold />} />
                          <ToolbarButton onClick={() => document.execCommand("italic")} icon={<LuItalic />} />
                          <ToolbarButton onClick={() => document.execCommand("underline")} icon={<LuUnderline />} />
                          <div className="w-px h-6 bg-gray-200 mx-1"></div>
                          {/* Alignment */}
                          <ToolbarButton onClick={() => document.execCommand("justifyLeft")} icon={<LuAlignLeft />} />
                          <ToolbarButton onClick={() => document.execCommand("justifyCenter")} icon={<LuAlignCenter />} />
                          <ToolbarButton onClick={() => document.execCommand("justifyRight")} icon={<LuAlignRight />} />
                          <ToolbarButton onClick={() => document.execCommand("justifyFull")} icon={<LuAlignJustify />} />
                        </div>
                        <div
                          ref={this.editorRef}
                          contentEditable
                          suppressContentEditableWarning
                          className="w-full h-80 p-6 outline-none resize-none textblack leading-relaxed"
                          style={{ direction: "ltr", textAlign: "left" }}
                        />
                      </div>
                    </div>
                  </main>
                )}

                {!showReply && (
                  <>
                    <main className={`flex-1 flex flex-col bg-white overflow-y-auto ${!this.state.showMobileDetail ? 'hidden lg:flex' : 'flex'}`}>
                      {/* Action Bar */}

                      {isMobile ?
                        <div className="flex flex-wrap items-center justify-end gap-2 p-[18px] border-b border-gray-300">
                          {/* <button onClick={() => this.setState({ showMobileDetail: false })} className="lg:hidden mr-auto p-2 text-indigo-600"><LuArrowLeft /></button> */}
                          <button onClick={this.handleOpenReply} className="flex items-center gap-2 px-4 py-2 text-sm textblack"><LuReply size={18} /> Reply</button>
                          <div className="h-6 w-px bg-gray-200 ml-2"></div>
                          <button className="flex items-center gap-2 px-2 py-2 text-sm textblack"><LuPrinter size={18} /> Print</button>
                        </div>
                        :
                        <div className="md:block hidden md:flex flex-wrap items-center justify-end gap-2 p-[16px] border-b border-gray-300">
                          <button onClick={this.handleOpenReply}
                            className="cursor-pointer flex items-center gap-2 px-4 py-2 text-sm textblack hover:bg-gray-100 rounded-md hover:text-indigo-600"
                          ><LuReply size={18} /> Reply</button>
                          {/* <button className="cursor-default flex items-center gap-2 px-4 py-2 text-sm text-gray-400"><LuReplyAll size={18} /> Reply to all</button> */}
                          {/* <button className="cursor-default flex items-center gap-2 px-4 py-2 text-sm text-gray-400"><LuForward size={18} /> Forward</button> */}
                          {/* <div className="h-6 w-px bg-gray-200 ml-2"></div> */}
                          {/* <button className="cursor-default flex items-center gap-2 px-2 py-2 text-sm text-gray-400 "><LuTrash2 size={18} /> Delete</button> */}
                          {/* <button className="cursor-default flex items-center gap-2 px-2 py-2 text-sm text-gray-400"><LuPrinter size={18} /> Print</button> */}
                        </div>
                      }


                      {(getInsightMailReplyData && getInsightMailReplyData.length > 0) && activeMail ?
                        <>
                          <div className="md:p-6 px-4 w-full mx-auto">
                            <h2 className="md:text-2xl text-xl textblack font-medium mb-6 md:mt-0 mt-4">{activeMail.subject}</h2>
                            {/* Original Message Header */}
                            <div className="flex items-start md:gap-4 gap-2 mb-4">
                              <div className="md:w-12 md:h-12 w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center font-medium flex-shrink-0 text-base">
                                {"M"}</div>
                              <div className="flex-1 min-w-0 relative">
                                <div className="flex justify-between">
                                  <div className="flex flex-wrap justify-between">
                                    <p className="text-sm">


                                      <span className="textblack">From: </span>
                                      <span className="font-semibold">{activeMail.senderName}</span>
                                      <span className="textblack">({activeMail.senderEmail})</span><br />

                                      {activeMail && activeMail.senderDesignation &&
                                        <>
                                          <span className="textblack">Designation: </span>
                                          <span className="font-semibold">{activeMail.senderDesignation}</span>
                                        </>
                                      }<br />


                                      <span className="textblack">To: </span>
                                      <span className="font-semibold">{activeMail.recipientName}</span>

                                      {activeMail && activeMail.recipientEmail &&
                                        <>
                                          <span className="textblack">({activeMail.recipientEmail})</span>
                                        </>
                                      }<br />

                                      {activeMail && activeMail.cc &&
                                        <>
                                          <span className="textblack">CC: </span>
                                          <span className="font-semibold">{activeMail.cc}</span><br />
                                        </>
                                      }

                                      {activeMail && activeMail.received &&
                                        <>
                                          <span className="textblack">Received: </span>
                                          <span className="font-semibold">{activeMail.received}</span><br />
                                        </>
                                      }



                                    </p>
                                    {/* <span className="text-sm font-medium text-indigo-600">{activeMail.fullDate} {activeMail.time}</span> */}
                                  </div>

                                  <div className="flex px-2">
                                    <button onClick={(e) => this.toggleViewMenu()} className="p-1 hover:bg-gray-100 rounded-lg h-fit">
                                      {activeViewId ? <LuChevronUp size={20} /> : <LuChevronDown size={20} />}
                                    </button>
                                  </div>
                                </div>

                                <p className="mt-4 textblack italic">{activeMail.mainMessage}</p>

                                {/* Floating Menu Popup */}
                                {this.state.activeMenueMail === activeMail.id && (
                                  <div className="absolute right-0 top-8 w-40 bg-white shadow-[0px_10px_30px_rgba(0,0,0,0.15)] rounded-xl border border-gray-100 z-20 overflow-hidden animate-in fade-in zoom-in duration-200">
                                    <button className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-indigo-100 transition-colors border-b border-gray-50">
                                      <LuPencil size={16} /> Edit
                                    </button>
                                    <button className="w-full flex items-center gap-3 px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition-colors">
                                      <LuTrash2 size={16} /> Delete
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>


                            {activeViewId &&
                              <div className="pb-4">
                                {activeMail.body && (
                                  <div
                                    className="textblack text-sm leading-relaxed space-y-4"
                                    dangerouslySetInnerHTML={{ __html: activeMail.body }}
                                  />
                                )}
                              </div>
                            }

                            <h3 className="font-semibold text-lg pt-6 mb-3 pb-3 border-t border-b border-gray-300">Replies ({getInsightMailReplyData.length})</h3>

                            {/* Replies Thread */}
                            <div className="mt-6 pb-16">
                              <div className="space-y-6">
                                {getInsightMailReplyData.map((reply) => (
                                  <div key={reply.id} className="relative border-b border-gray-300 pb-6 last:border-0">
                                    <div className="flex gap-4">
                                      <div className="md:w-12 md:h-12 w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center font-medium flex-shrink-0 text-base">
                                        {"R"}</div>
                                      <div className="flex-1 relative">
                                        <div className="flex justify-between">
                                          <div>
                                            <p className="text-base font-medium textblack">Replied By: {reply.recipientName}</p>
                                            <p className="text-sm text-indigo-600 pt-0.5">{reply.date} {reply.time} 25 April, 12:25 pm</p>
                                          </div>

                                          <button onClick={(e) => this.toggleMenu(e, reply.id)} className="p-1 hover:bg-gray-100 rounded-lg h-fit">
                                            <LuMoreVertical />
                                          </button>
                                        </div>

                                        {reply.body && (
                                          <div
                                            className="textblack text-sm leading-relaxed space-y-4"
                                            dangerouslySetInnerHTML={{ __html: reply.body }}
                                          />
                                        )}



                                        {/* Floating Menu Popup */}
                                        {this.state.activeMenuId === reply.id && (
                                          <div className="absolute right-0 top-8 w-40 bg-white shadow-[0px_10px_30px_rgba(0,0,0,0.15)] rounded-xl border border-gray-100 z-20 overflow-hidden animate-in fade-in zoom-in duration-200">
                                            <button onClick={() => this.editReplyMail(reply)} className="w-full flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-indigo-100 transition-colors border-b border-gray-50">
                                              <LuPencil size={16} /> Edit
                                            </button>
                                            <button onClick={() => this.deleteReplyConfirm(reply)} className="w-full flex items-center gap-3 px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition-colors">
                                              <LuTrash2 size={16} /> Delete
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                        :
                        <>
                          {/* Email Body */}
                          {activeMail &&
                            <div className="md:p-6 p-4 w-full">
                              <h2 className="md:text-2xl text-xl font-medium mb-6">{activeMail.subject}</h2>

                              <div className="flex items-start justify-between mb-8">
                                <div className="flex md:items-center items-start md:gap-4 gap-2">
                                  <div className="md:w-12 md:h-12 w-9 h-9 rounded-full bg-indigo-600 text-white flex items-center justify-center shrink-0 font-medium text-base">
                                    {activeMail.initials || "U"}
                                  </div>
                                  <p className="text-sm">


                                    <span className="textblack">From: </span>
                                    <span className="font-semibold">{activeMail.senderName}</span>
                                    <span className="textblack">({activeMail.senderEmail})</span><br />

                                    {activeMail && activeMail.senderDesignation &&
                                      <>
                                        <span className="textblack">Designation: </span>
                                        <span className="font-semibold">{activeMail.senderDesignation}</span>
                                      </>
                                    }<br />


                                    <span className="textblack">To: </span>
                                    <span className="font-semibold">{activeMail.recipientName}</span>

                                    {activeMail && activeMail.recipientEmail &&
                                      <>
                                        <span className="textblack">({activeMail.recipientEmail})</span>
                                      </>
                                    }<br />

                                    {activeMail && activeMail.cc &&
                                      <>
                                        <span className="textblack">CC: </span>
                                        <span className="font-semibold">{activeMail.cc}</span><br />
                                      </>
                                    }

                                    {activeMail && activeMail.received &&
                                      <>
                                        <span className="textblack">Received: </span>
                                        <span className="font-semibold">{activeMail.received}</span><br />
                                      </>
                                    }



                                  </p>
                                </div>
                                <div className="text-right">
                                  {/* <p className="text-sm font-semibold text-indigo-600">{activeMail.fullDate} {activeMail.time}</p> */}
                                </div>
                              </div>

                              {activeMail.body && (
                                <div
                                  className="textblack text-sm leading-relaxed space-y-4"
                                  dangerouslySetInnerHTML={{ __html: activeMail.body }}
                                />
                              )}

                            </div>
                          }
                        </>}

                    </main>
                  </>
                )}
              </>}




          </div>


          {showDeleteConfirm ?
            <>
              <DeleteReplyModal
                onDelete={this.deleteReplyMail}
                onClose={this.onCloseDeleteConfirm}
              />
            </>
            : null}



        </div>
      </LayoutWrap>
    );
  }
}

// Sub-component for Toolbar Buttons
const ToolbarButton = ({ icon, onClick }) => (
  <button onClick={onClick} className="p-2 textblack hover:bg-[#A78BFA] rounded transition-colors">
    {React.cloneElement(icon, { size: 18 })}
  </button>
);

export default connect((state) => ({
  dashboard: state.dashboard,
}))(InboxActivity);